<template>
	<div>
		<!-- 产品管理 -->
		<div class="cardlist">
			<div class="card">
				<div class="p1">染发</div>
				<div class="p2">月销总量</div>
				<div class="p3">30000</div>
			</div>
			<div class="card">
				<div class="p1">烫发</div>
				<div class="p2">月销总量</div>
				<div class="p3">30000</div>
			</div>
		</div>
		<el-button type="primary" style="margin-top: 25px;" @click="goaddhair" size="small">新建服务</el-button>
		<el-table :cell-style="{'text-align':'center'}"
			:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
			tooltip-effect="dark" style="width: 100%;margin-top: 15px;">
			<el-table-column prop="title" label="产品服务名称">
			</el-table-column>
			<el-table-column prop="type" label="服务类型">
				<template slot-scope="scope">
					{{scope.row.type | typeFormat}}
				</template>
			</el-table-column>
			<el-table-column prop="msg" label="服务描述">
			</el-table-column>
			<el-table-column prop="letter" label="排队标识">
			</el-table-column>
			<el-table-column prop="updateTime" label="创建日期">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="delit(scope.row.id)">编辑</el-button>
					<el-button type="text" @click="updown(scope.row.id, scope.row.state==0?1:0)" style="color:#e36">
						{{scope.row.state==0?"上架":"下架"}}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				pages: {
					total: "",
					pageNum: 1,
					pageSize: 100,
					type: 1
				},
				tableData: []
			}
		},
		mounted() {
			this.getlist()
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case 0:
						return "剪发服务";
					case 1:
						return "染发服务";
					case 2:
						return "洗吹服务";
					default:
						return "/";
				}
			}
		},
		methods: {
			//编辑
			delit(id) {
				this.$router.push({
					path: 'add_hair',
					query: {
						id: id
					}
				})
			},
			// 上架下架
			updown(id, state) {
				let data = {
					id: id,
					state: state,
				}
				this.$http.post("dhaircut/shelfService", JSON.stringify(data)).then(res => {
					if (res.body.code != 200) {
						this.$message.error(res.body.msg);
					} else {
						this.getlist()
						this.$message.success("上架/下架成功！");
					}
				})
			},
			goaddhair() {
				this.$router.push({
					path: "/add_hair"
				})
			},
			// 获取剪发列表
			getlist() {
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(this.pages)).then(function(res) {
					if (res.body.code == 200) {
						// this.tableData=res.body.data.records
						this.tableData = res.body.data
						this.pages.total = res.body.data.total
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
		}
	}
</script>
<style lang="less" scoped>
	.cardlist {
		display: flex;

		.card {
			padding: 15px;
			box-sizing: border-box;
			background-color: #F2F2F2;
			border-radius: 5px;
			margin-left: 20px;
			flex: 1;

			&:nth-child(1) {
				margin-left: 0px;
			}

			.p1 {
				font-size: 20px;
				font-weight: bold;
			}

			.p2 {
				font-size: 18px;
				margin-top: 10px;
			}

			.p3 {
				font-size: 40px;
				text-align: center;
				margin-top: 20px;
				margin-bottom: 20px;
			}
		}
	}
</style>